module.exports = __webpack_public_path__ + "img/dialog_image_S207P.aab25a1c.png";